export enum TipoLayout {
    PADRAO = 'PADRAO',
    REDUZIDO = 'REDUZIDO',
}